import { Box } from '@mui/material';
import { Typography } from 'src/components/new/Typography';

interface DocProcessingColumnProps {
  data: { id: number; name: string; isDirty: boolean; value: string }[];
  title: string;
  isEditable: boolean;
  onInputChange: (e: any, id: number) => void;
}

const RATE_NAMES_MAP = {
  standard_page: 'Standard Page',
  rush_service: 'Rush Service',
  color_ink: 'Color Ink',
  colored_paper: 'Colored Paper',
  return_envelope: 'Return Envelope',
  flat: 'Flat',
  flat_rate_envelope: 'Flat Rate Envelope',
  legal_flat_rate_envelope: 'Legal Flat Rate Envelope',
  flat_rate_box: 'Flat Rate Box',
  print_minimum: 'Print Minimum',
  special_cos: 'Special COS',
};

const DocProcessingColumn: React.FC<DocProcessingColumnProps> = ({ data, title, isEditable, onInputChange }) => {
  return (
    <Box sx={{ flex: 1 }}>
      <Box sx={{ backgroundColor: '#cee2ff', padding: 1 }}>
        <Typography fontWeight={550}>{title}</Typography>
      </Box>
      {data.map((item) => {
        return (
          <Box
            sx={{
              padding: 2,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderBottom: '1px solid #7e828b',
            }}
            key={item.id}
          >
            <Typography fontSize={14} fontWeight={500}>
              {RATE_NAMES_MAP[item.name as keyof typeof RATE_NAMES_MAP]}
            </Typography>
            <input
              style={{
                height: '3rem',
                borderRadius: '0.3125rem',
                textAlign: 'right',
                border: '0.0625rem solid #7e828b',
                backgroundColor: item.isDirty ? '#ffeedf' : '#f6f6f6',
                borderColor: item.isDirty ? '#7b3f07' : '',
                color: isEditable ? '' : '#7e828b',
                marginRight: '1rem',
              }}
              onChange={(e) => onInputChange(e, item.id)}
              value={item.value}
              id={item.id.toString()}
              disabled={!isEditable}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default DocProcessingColumn;
